import React from 'react';

import { Box, Divider, Typography } from '@mui/material';

import { appRoutes } from '@clearverify/constants';

import { Link } from 'src/components/common';

import { LoginForm } from '../LoginForm';
import { LoginMfaForm } from '../LoginMfaForm';
import { SsoLogin } from '../SsoLogin/SsoLogin';

import { LOGIN_RESULT_DEFAULT_VALUE } from './constants';
import type { LoginResultWithEmail } from './types';

export const Login: React.FC = () => {
  const [loginData, setLoginData] = React.useState(LOGIN_RESULT_DEFAULT_VALUE);
  const [isDisabled, setIsDisabled] = React.useState(false);

  const isMfaEnabled = React.useMemo(() => {
    return !!loginData.session;
  }, [loginData.session]);

  const handleLoginResult = React.useCallback(
    (data: LoginResultWithEmail) => setLoginData(data),
    [],
  );

  if (isMfaEnabled) {
    return (
      <React.Fragment>
        <Box>
          <Typography variant="h5" mt={1}>
            Multi-factor Authentication
          </Typography>

          <Typography variant="body1" color="text.secondary" mt={1}>
            Let’s make sure it’s you. Enter your Verification Code from authentication app
          </Typography>
        </Box>

        <LoginMfaForm loginData={loginData} handleLoginResult={handleLoginResult} />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Box>
        <Typography variant="h5" mt={1}>
          Sign into Clear Verify
        </Typography>

        <Typography variant="body1" color="text.secondary" mt={1}>
          Don’t have an account? <Link to={appRoutes.auth.index}>Sign up</Link>
        </Typography>
      </Box>

      <LoginForm
        loginData={loginData}
        handleLoginResult={handleLoginResult}
        isLoginDisabled={isDisabled}
        switchLoginDisabledState={setIsDisabled}
      />

      <Divider>OR</Divider>

      <SsoLogin isLoginDisabled={isDisabled} switchLoginDisabledState={setIsDisabled} />
    </React.Fragment>
  );
};
